/* This file is autogenerated, see readme.md for instructions */
import FileSvgIcon from '@bloomreach/banana-theme/icons/file.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FileIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FileSvgIcon />
    </Icon>
  );
});

FileIcon.displayName = 'FileIcon';

export default FileIcon;
